@let blocCompetences = bloc();

<div class="px-xl border-grey-3 -mx-6 flex flex-col border-b bg-white">
  <div class="gap-xs my-md flex">
    <a
      [routerLink]="['..']"
      hlmBtn
      size="icon"
      variant="ghost"
      aria-label="Retourner au croisement du référentiel"
      hlmTooltipTrigger="Retourner au croisement du référentiel"
    >
      <ng-icon hlm name="lucideArrowLeft" />
    </a>
    <div class="flex flex-col">
      <h1 class="title-medium-semibold">Bloc de compétences</h1>
      <h2 class="title-small-medium">{{ blocCompetences.codeBloc }} - {{ blocCompetences.nom }}</h2>
    </div>
  </div>
  <app-stepper (selectionChange)="redirect($event)">
    <app-step label="Gestion des compétences de certification" />
    <app-step label="Association des aptitudes" />
  </app-stepper>
</div>
<div class="mx-xl my-lg flex flex-col">
  <div class="gap-xs flex items-center">
    <span class="title-small-medium">Référentiel de certification</span>
    <ng-icon name="lucideDot" hlm size="base" />
    <a
      class="paragraph-medium-semibold"
      [href]="urlFranceCompetencesRecherche + (certification().codeFiche | getIdFiche)"
      target="_blank"
      hlmBtn
      variant="link"
      size="compact"
      >Lien vers France Compétences</a
    >
  </div>
  <div class="mt-sm">
    <router-outlet />
  </div>
</div>
